import { render, staticRenderFns } from "./PageLayoutHeader.vue?vue&type=template&id=3fb5f554"
import script from "./PageLayoutHeader.vue?vue&type=script&lang=js"
export * from "./PageLayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./PageLayoutHeader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports